import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { UserService } from "../../@core/services/user.service";
import { ExerciseQuiz } from "../../models/exercise.model";

import Quiz from "../../models/quiz.model";
import { QuizContentService } from "../../services/quiz-content.service";
import { DialogTestQuizComponent } from "../dialog-test-quiz/dialog-test-quiz.component";

@Component({
  selector: "ngx-dialog-link-quizzes",
  templateUrl: "dialog-link-quizzes.component.html",
  styleUrls: ["dialog-link-quizzes.component.scss"],
})
export class DialogLinkQuizzesComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() description?: string;
  @Input() exQuizzes?: ExerciseQuiz[];
  @Input() quizzes?: Quiz[];

  displays?: Quiz[];

  submitted = false;
  strSearch = "";
  uid = "";

  constructor(
    protected ref: NbDialogRef<DialogLinkQuizzesComponent>,
    private userService: UserService,
    private quizContentService: QuizContentService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.loadQuizzes(user.uid);
        } else {
          this.uid = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadQuizzes(uid): void {
    this.quizContentService
      .getQuizzes(uid)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.quizzes = data;
        this.quizzes = this.quizzes.filter(
          function (item) {
            var objF = this.list.find((el) => el.quizId == item.id);
            return objF ? false : true;
          },
          {
            list: this.exQuizzes ? this.exQuizzes : [],
          }
        );
        this.displays = [...this.quizzes];
      });
  }

  search() {
    this.strSearch = this.strSearch.toLowerCase();
  }

  cancel() {
    this.ref.close();
  }

  selected(item) {
    this.submitted = true;
    this.ref.close(item);
  }

  onSearch(): void {
    this.displays = this.quizzes.filter(
      function (item) {
        return item.title.toLowerCase().includes(this.title);
      },
      { title: this.strSearch }
    );
  }

  testQuiz(id) {
    this.dialogService.open(DialogTestQuizComponent, {
      context: {
        quizId: id,
      },
      closeOnBackdropClick: false,
    });
  }
}
